import * as en from './en/index.json';
import * as fr from './fr/index.json';
import * as de from './de/index.json';
import * as es from './es/index.json';

export const i18LocalLocales = {
  en,
  fr,
  de,
  es,
};
